export default __webpack_public_path__ + "static/media/padag.128a03ae.png";